<template>
  <nav class="pagination">
    <router-link
      class="pagination__link"
      :class="{ 'pagination__link--disabled': currentPage === 1}"
      :to="routeConfig(currentPage - 1)"
    >
      <ag-icon name="chevron-left" />
    </router-link>
    <div
      v-if="!slim"
      class="pagination__indicator">
      {{currentPage}} / {{pageCount}}
    </div>
    <router-link
      class="pagination__link"
      :class="{ 'pagination__link--disabled': currentPage === pageCount}"
      :to="routeConfig(currentPage + 1)"
    >
      <ag-icon name="chevron-right" />
    </router-link>
  </nav>
</template>

<script>
import AgIcon from './AgIcon.vue';

/**
 * @vuese
 * This component can paginate everything. It needs some information
 * of total available pages `pageCount` and the `currentPag` and produce
 * vue router friendly links with a `page=xx` GET paramter.
 * All existing get parameters will be untouched and paginated too.
 */
export default {
  name: 'ag-pagination',
  components: {
    AgIcon,
  },
  props: {
    /**
     * flag if only `<` `>` pagination buttons should be visible
     */
    slim: {
      type: Boolean,
      default: false,
    },
    /**
     * maximum pages available
     */
    pageCount: {
      type: Number,
      default: 0,
    },
    /**
     * the page you actually view
     */
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    /**
     * helper function to prepare a `query` object for the generated vue-router pagination links
     * all existing get parameters will be included in your pagination
     * @arg {Number} page to paginate to
     */
    routeConfig(page) {
      let toPage = page < 1 ? 1 : page;
      toPage = toPage > this.pageCount ? this.pageCount : toPage;
      return {
        query: {
          ...this.$route.query,
          page: toPage,
        },
      };
    },
  },
};
</script>

<style lang="scss">
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  &__indicator {
    $font-size: 14px;
    font-size: rem(14px);
    color: $text-color;
    font-weight: 700;
    padding: em(6px, $font-size);
  }

  &__link {
    color: $text-color;
    padding: em(6px);
    display: flex;
    align-items: center;

    &--disabled {
      pointer-events: none;
      color: #ccc !important;
    }
  }
}
</style>
